<template>
    <div>
        <form>
            <input type="text" name="buyer.email" maxlength="50" v-model="order.buyer.email" />
            <input type="text" name="buyer.phone" maxlength="50" v-model="order.buyer.phone" />
            <input type="text" name="buyer.firstName" maxlength="50" v-model="order.buyer.firstName" />
            <input type="text" name="buyer.language" maxlength="50" value="pl" />

            <input type="text" name="description" v-model="order.description" maxlength="50"  />
            <input type="text" name="extOrderId" v-model="order.extOrderId" maxlength="50"  />
            <input type="text" name="totalAmount" v-model="order.totalAmount" maxlength="50"  />
            <input type="text" name="buyer.language" v-model="order.language" maxlength="50"  />
            <input type="text" name="notifyUrl" v-model="order.notifyUrl" value="" />
            <input type="text" name="customerIp" v-model="order.customerIp" maxlength="25"  />
            <input type="text" name="merchantPosId" v-model="order.merchantPosId" maxlength="25"  />
            <input type="text" name="currencyCode" v-model="order.currencyCode" maxlength="50"  />
            <input type="text" name="continueUrl" v-model="order.continueUrl" />
        </form>
    </div>
</template>

<script>
    export default {
        name: 'payuForm',
        props: ['step', 'order'],
        data () {
            return {
                urls: {
                    sendOrder: 'zadbanoApiapi/sendOrder/'
                }
            }
        },

        mounted: function () {

        },

        methods: {
            sendForm: function (e) {
                console.log('sendForm');
                var self = this;
                //e.stopPropagation();
                e.preventDefault();
                var valid = true;
                if (valid) {
                    return self.request({
                            method: 'post',
                            endPoint: self.urls.sendOrder},
                        {
                            order: self.order,
                            buyer: self.order.buyer
                        })
                        .done(function (data) {
                            if (!_.isEmpty(data)) {
                                if (!_.isEmpty(data.redirectUrl)) {
                                    console.log(data.redirectUrl);
                                    window.location.href = data.redirectUrl;
                                }
                            }
                        });
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// PayuForm.vue?6921ac3b